module.exports = __webpack_public_path__ + "static/media/Picture6.a85302d0.png";